var _defs, _path, _path2, _g, _tspan, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgProductScan = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "ProductScan_svg__Crop_Marks",
  viewBox: "0 0 37.21 39.11"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ProductScan_svg__cls-2,.ProductScan_svg__cls-3{isolation:isolate}.ProductScan_svg__cls-3{fill:#dde0e8;font-family:Muli-Bold,Muli;font-weight:700}.ProductScan_svg__cls-6{fill:none;stroke-linecap:round;stroke-width:2px;stroke:#129bf9;stroke-miterlimit:10}.ProductScan_svg__cls-3{font-size:2px;letter-spacing:.02em}"))), /*#__PURE__*/React.createElement("g", {
  id: "ProductScan_svg__Group_61089"
}, /*#__PURE__*/React.createElement("g", {
  id: "ProductScan_svg___1_Bagcode_Scan"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "ProductScan_svg__Path_76902",
  d: "M2.54 8.51V4.33c0-.54.44-.97.97-.97h4.18",
  className: "ProductScan_svg__cls-6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "ProductScan_svg__Path_76902-2",
  d: "M7.72 35.73H3.53a.97.97 0 0 1-.97-.97h0v-4.18",
  className: "ProductScan_svg__cls-6"
})), /*#__PURE__*/React.createElement("path", {
  id: "ProductScan_svg__Line_216-2",
  d: "M2.26 19.89h32.38",
  style: {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#ff2d39"
  }
}), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ProductScan_svg__Group_60940"
}, /*#__PURE__*/React.createElement("path", {
  id: "ProductScan_svg__Path_76902-3",
  d: "M34.94 8.51V4.33a.97.97 0 0 0-.97-.97h-4.18",
  className: "ProductScan_svg__cls-6"
}), /*#__PURE__*/React.createElement("path", {
  id: "ProductScan_svg__Path_76902-4",
  d: "M29.79 35.76h4.18c.54 0 .97-.44.97-.97h0v-4.18",
  className: "ProductScan_svg__cls-6"
}))), /*#__PURE__*/React.createElement("path", {
  id: "ProductScan_svg__Line_2244",
  d: "M19.09 14.06h11.9",
  style: {
    stroke: "#fefeff",
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }
}), /*#__PURE__*/React.createElement("path", {
  id: "ProductScan_svg__Line_2245",
  d: "M6.4 24.36h25.08",
  style: {
    fill: "none",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeLinejoin: "round",
    stroke: "#c0c4c8"
  }
}), /*#__PURE__*/React.createElement("g", {
  id: "ProductScan_svg__Group_60941"
}, /*#__PURE__*/React.createElement("g", {
  id: "ProductScan_svg___4"
}, /*#__PURE__*/React.createElement("text", {
  id: "ProductScan_svg__K",
  className: "ProductScan_svg__cls-2",
  style: {
    fontSize: 3,
    letterSpacing: ".02em",
    isolation: "isolate",
    fill: "#dde0e8",
    fontFamily: "Muli-Bold,Muli",
    fontWeight: 700
  },
  transform: "translate(5.6 13.9)"
}, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "K")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "ProductScan_svg___8"
}, /*#__PURE__*/React.createElement("g", {
  id: "ProductScan_svg___2",
  className: "ProductScan_svg__cls-2"
}, /*#__PURE__*/React.createElement("text", {
  className: "ProductScan_svg__cls-3",
  transform: "translate(10.11 12.9)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "2"))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  id: "ProductScan_svg___3"
}, /*#__PURE__*/React.createElement("g", {
  id: "ProductScan_svg___4-2",
  className: "ProductScan_svg__cls-2"
}, /*#__PURE__*/React.createElement("text", {
  className: "ProductScan_svg__cls-3",
  transform: "translate(13.92 12.9)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "4")))))))));
export default SvgProductScan;